import { Trans } from "react-i18next";
import React from "react";
import { useAuth } from "@shared/context/AuthContext";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const RequireAuth: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Wait for auth check to complete before redirecting
  if (loading) {
    return (
      <div
        className="min-vh-100 d-flex align-items-center justify-content-center"
        aria-live="polite"
      >
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden"><Trans ns="features" i18nKey="ui.copy.7acbc8dd047a" /></span>
          </div>
          <p className="mt-3 mb-0 text-muted"><Trans ns="features" i18nKey="ui.copy.7acbc8dd047a" /></p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default RequireAuth;
